import { render } from "./SapXep.vue?vue&type=template&id=2fabd9ac&scoped=true"
import script from "./SapXep.vue?vue&type=script&lang=js"
export * from "./SapXep.vue?vue&type=script&lang=js"

import "./SapXep.vue?vue&type=style&index=0&id=2fabd9ac&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fabd9ac"]])

export default __exports__